/*
 * Embroidery text filter (SOUS-128)
 * - Verwijdert emoji uit de borduur-tekstvelden en toont een melding.
 * - Zet alle hartjes-emoji om naar ♥ (zonder melding).
 * - © ® ™ ♥ ★ ☺ ☀ blijven toegestaan.
 * Draait in de capture-fase, dus vóór de input-listener van de configurator:
 * de configurator (preview, samenvatting, winkelmand) krijgt altijd de schone tekst.
 */
(() => {
  if (window.__lncEmbroideryTextFilter) return;
  window.__lncEmbroideryTextFilter = true;

  const SELECTOR = 'input[name^="embroideryNameLine"][name$="Text"]';
  const DUUR_MS = 5000;

  const TEKSTEN = {
    nl: 'Emoji kunnen niet geborduurd worden en zijn verwijderd.',
    en: "Emoji can't be embroidered and have been removed.",
    de: 'Emojis können nicht gestickt werden und wurden entfernt.',
    fr: 'Les émojis ne peuvent pas être brodés et ont été supprimés.',
    es: 'Los emojis no se pueden bordar y se han eliminado.',
    it: 'Le emoji non possono essere ricamate e sono state rimosse.',
  };

  const HARTJES = /[❣❤\u{1F493}\u{1F495}-\u{1F498}\u{1F499}-\u{1F49E}\u{1F5A4}\u{1F90D}\u{1F90E}\u{1F9E1}\u{1FA75}-\u{1FA77}]/gu;
  const EMOJI = /(?![©®™♥★☺☀])\p{Extended_Pictographic}|[\u{FE0F}\u{200D}\u{20E3}\u{1F3FB}-\u{1F3FF}\u{1F1E6}-\u{1F1FF}\u{E0020}-\u{E007F}]/gu;

  function schoonTekst(tekst) {
    const metHartjes = tekst.replace(HARTJES, '♥');
    // Geen dubbele spaties in de borduring, ook niet waar een emoji is weggehaald ("Jan 😀 ♥" -> "Jan ♥")
    const zonderEmoji = metHartjes.replace(EMOJI, '');
    const emojiVerwijderd = metHartjes.replace(/\u{FE0F}/gu, '') !== zonderEmoji;
    const schoon = zonderEmoji.replace(/ {2,}/g, ' ');
    return { schoon, emojiVerwijderd };
  }
  window.lncSchoonBorduurTekst = schoonTekst;

  function meldingTekst() {
    const taal = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    return TEKSTEN[taal] || TEKSTEN.en;
  }

  const timers = new WeakMap();

  function meldingElement(input) {
    const veld = input.closest('.field') || input.parentElement;
    let el = veld.parentElement.querySelector('[data-embroidery-emoji-melding]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-embroidery-emoji-melding', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.className = 'text-xs text-danger mt-2 flex items-start gap-1';
      el.hidden = true;
      el.innerHTML =
        '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" style="flex:none;margin-top:1px"><circle cx="8" cy="8" r="6.5"/><path d="M8 4.5v4.5M8 11.2v.1" stroke-linecap="round"/></svg><span></span>';
      // na de "Max xx characters"-regel plaatsen, anders direct na het veld
      const maxRegel = veld.nextElementSibling;
      (maxRegel && maxRegel.tagName === 'P' ? maxRegel : veld).after(el);
    }
    return el;
  }

  function toonMelding(input) {
    const el = meldingElement(input);
    el.querySelector('span').textContent = meldingTekst();
    el.hidden = false;
    input.style.borderColor = getComputedStyle(el).color;
    clearTimeout(timers.get(input));
    timers.set(input, setTimeout(() => {
      el.hidden = true;
      input.style.borderColor = '';
    }, DUUR_MS));
  }

  function verwerk(input) {
    const origineel = input.value;
    const { schoon, emojiVerwijderd } = schoonTekst(origineel);
    if (schoon !== origineel) {
      const pos = Math.max(0, (input.selectionStart ?? origineel.length) - (origineel.length - schoon.length));
      input.value = schoon;
      try { input.setSelectionRange(pos, pos); } catch (e) { /* niet alle velden ondersteunen dit */ }
    }
    if (emojiVerwijderd) toonMelding(input);
    return schoon !== origineel;
  }

  // Capture-fase: loopt vóór de listeners van de configurator.
  document.addEventListener('input', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(SELECTOR)) return;
    if (e.isComposing) return; // tijdens samengestelde invoer (bv. mobiel toetsenbord) niet ingrijpen
    verwerk(input);
  }, true);

  // Na samengestelde invoer alsnog opschonen en de configurator bijwerken.
  document.addEventListener('compositionend', (e) => {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(SELECTOR)) return;
    if (verwerk(input)) input.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);
})();
